<template>
	<div>
		<!-- Next request card -->
		<!-- Pendiente de confirmación con el cliente si será visible o no -->
		<!-- <b-card v-if="nextRequest" no-body class="mb-2 border-primary">
			<div class="d-flex align-items-center p-1">
				<div class="mr-1">
					<feather-icon icon="CalendarIcon" size="24" class="text-primary" />
				</div>
				<div>
					<div class="text-primary" style="font-size: 0.9rem;">Próxima Solicitud</div>
					<div>
						<strong>{{ nextRequest.typeLabel }}</strong> : {{ nextRequest.dateLabel }}
					</div>
				</div>
			</div>
		</b-card> -->

		<!-- Filters -->
		<forms-list-filters :conditions-filter.sync="conditionsFilter" />

		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refFormsListTable"
				class="position-relative"
				:style="'height: inherit'"
				:items="fetchForms"
				responsive
				:fields="tableColumns"
				primary-key="id"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #head(start_date)="data">
					<span v-html="data.label"></span>
				</template>

				<template #cell(start_date)="data">
					<b-badge variant="light-info">{{ data.item.month }}</b-badge>
				</template>

				<template #cell(evidence_type)="data">
					<b-badge variant="light-primary">{{ evidenceTypeLabel(data.item.start_date) }}</b-badge>
				</template>

				<template #cell(state_name)="data">
					<b-badge :variant="data.item.state_color">{{ data.item.state_name }}</b-badge>
				</template>

				<template #cell(condition_name)="data">
					<b-badge :variant="data.item.condition_color">{{ data.item.condition_name }}</b-badge>
				</template>

				<template #cell(actions)="data">
					<BButtonUploadEvidence
						v-if="data.item.start_date >= '2026-03-01'"
						:form-id="data.item.id"
						:text="data.item.evidence_expired ? 'VER ARCHIVOS' : 'CARGAR DATOS'"
						:icon="data.item.evidence_expired ? 'EyeIcon' : 'UploadIcon'"
						:variant="data.item.evidence_expired ? 'outline-secondary' : 'outline-primary'"
						size="sm"
						@refetch-data="refetchData"
					/>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalForms"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import BButtonUploadEvidence from "@core/components/b-button-upload-evidence/BButtonUploadEvidence.vue"
import { ref, computed, onBeforeMount, onUnmounted } from "@vue/composition-api"
import FormsListFilters from "./FormsListFilters.vue"
import formStoreModule from "../formStoreModule"
import useFormsList from "./useFormsList"
import { getTypeForOpening, EVIDENCE_TYPES } from "@core/utils/cycleSchedule"
import vSelect from "vue-select"
import moment from "moment"
import store from "@/store"

export default {
	components: {
		BButtonUploadEvidence,
		FormsListFilters,

		vSelect
	},
	setup() {
		const PROVIDER_FORMS_APP_STORE_MODULE_NAME = "app-provider-forms"

		// REGISTER MODULE
		if (!store.hasModule(PROVIDER_FORMS_APP_STORE_MODULE_NAME))
			store.registerModule(
				PROVIDER_FORMS_APP_STORE_MODULE_NAME,
				formStoreModule
			)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(PROVIDER_FORMS_APP_STORE_MODULE_NAME))
				store.unregisterModule(PROVIDER_FORMS_APP_STORE_MODULE_NAME)
		})

		const {
			fetchForms,
			tableColumns,
			perPage,
			currentPage,
			totalForms,
			dataMeta,
			perPageOptions,
			sortBy,
			isSortDirDesc,
			refFormsListTable,
			refetchData,

			// EXTRA FILTERS
			conditionsFilter
		} = useFormsList()

		const nextDateCycle = ref(null)

		const TYPE_LABELS = {
			[EVIDENCE_TYPES.MENSUAL]: "MENSUAL",
			[EVIDENCE_TYPES.CTS]: "CTS",
			[EVIDENCE_TYPES.GRATIFICACION]: "GRATIFICACIÓN"
		}

		const nextRequest = computed(() => {
			if (!nextDateCycle.value) return null
			const type = getTypeForOpening(nextDateCycle.value)
			return {
				typeLabel: TYPE_LABELS[type] || type,
				dateLabel: moment(nextDateCycle.value).format("DD/MM/YYYY")
			}
		})

		const evidenceTypeLabel = (startDate) => {
			const type = getTypeForOpening(startDate)
			return TYPE_LABELS[type] || type
		}

		onBeforeMount(async () => {
			try {
				const response = await store.dispatch(
					`${PROVIDER_FORMS_APP_STORE_MODULE_NAME}/fetchMe`
				)
				nextDateCycle.value = response.data.provider.next_date_cycle
			} catch (_) {
				nextDateCycle.value = null
			}
		})

		return {
			fetchForms,
			tableColumns,
			perPage,
			currentPage,
			totalForms,
			dataMeta,
			perPageOptions,
			sortBy,
			isSortDirDesc,
			refFormsListTable,
			refetchData,

			nextRequest,
			evidenceTypeLabel,

			// EXTRA FILTERS
			conditionsFilter
		}
	}
}
</script>

<style lang="scss" scoped>
.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
